/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReportCommentFormContainer_settings = {
    readonly memberBios: boolean;
    readonly " $refType": "ReportCommentFormContainer_settings";
};
export type ReportCommentFormContainer_settings$data = ReportCommentFormContainer_settings;
export type ReportCommentFormContainer_settings$key = {
    readonly " $data"?: ReportCommentFormContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ReportCommentFormContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportCommentFormContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "memberBios",
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '046f790196ad3eb77f8cc0798d9c347d';
export default node;
